import Vue from "vue";
import { mapGetters, mapState } from "vuex";

import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import CheckboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import { Component, Prop, Watch } from "@/decorators";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import SubGrupoProduto from "@/models/enum/subGrupoProduto";
import TiposCalculoManipulacao from "@/models/enum/tiposCalculoManipulacao";
import { default as TiposItemManipulacao, default as TiposManipulacao } from "@/models/enum/tiposItemManipulacao";
import TiposProduto from "@/models/enum/tiposProduto";
import FormulaPadraoItemModel from "@/models/formulaPadraoItemModel";
import KitEmbalagemModel from "@/models/kitEmbalagemModel";
import ProdutoModel from "@/models/produto/produtoModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import UsuarioModel from "@/models/usuarioModel";
import IndicesConversoesUnidadeMedidasService from "@/services/indicesConversoesUnidadeMedidaService";
import kitEmbalagemService from "@/services/kitEmbalagemService";
import produtoESinonimosService from "@/services/produto/produtoESinonimosService";
import produtoService from "@/services/produto/produtoService";
import ProdutoLoteService from "@/services/produtoLoteService";
import unidadeMedidaService from "@/services/unidadeMedidaService";
import { AppState, Getters, SessionActions } from "@/store/store";
import arithmeticHelper from "@/utils/common/arithmeticHelper";
import { getProdutoLoteCombo } from "@/utils/common/combo/combotext";

import "./item.scss";

@Component({
    components: {
        comboComponent,
        decimalComponent,
        fieldsetComponent,
        dateTimePickerComponent,
        decimalComSinalCustomComponent,
        buttonIncluirComponent,
        CheckboxComponent,
    },
    computed: {
        ...mapState<AppState>({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters(["GET_IS_FRACIONAMENTO", "GET_IS_ESTEREIS"] as Getters),
    },
})
export default class FormulaPadraoItemComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;

    private possuiKit = false;
    private adicionarKit = false;

    private kitEmbalagemModel = new KitEmbalagemModel();
    private kitsModels: Array<KitEmbalagemModel> = [];
    private indicesConversoesUnidadeMedidasService = new IndicesConversoesUnidadeMedidasService();

    model = new FormulaPadraoItemModel();
    private tipoItem: TiposProduto = null;

    private updateMode = false;

    private changeProdutoId = false;
    private produtoId = null;
    isFracionamento = false;
    isEstereis = false;

    produtosOptions: Array<Object> = [];
    lotesReprocessadosOptions: Array<Object> = [];
    unidadesMedidaManipulacaoOptions: Array<Object> = [];
    unidadeMedidaOptions: Array<Object> = [];
    tiposManipulacaoOptions: Array<Object> = [
        { text: "Todos", value: 99 },
        { text: "Capsula", value: TiposProduto.Capsula },
        { text: "Embalagem", value: TiposProduto.Embalagem },
        { text: "Materia Prima", value: TiposProduto.MateriaPrima },
        { text: "Semi-Acabados", value: TiposProduto.SemiAcabado },
    ];
    tiposCalculoOptions: Array<Object> = [
        { text: "Nenhum", value: TiposCalculoManipulacao.Nenhum },
        { text: "Unitario", value: TiposCalculoManipulacao.Unitario },
        { text: "Dose", value: TiposCalculoManipulacao.Dose },
        { text: "Percentual", value: TiposCalculoManipulacao.Percentual },
        { text: "Qsp", value: TiposCalculoManipulacao.Qsp },
        { text: "DH", value: TiposCalculoManipulacao.DH },
        { text: "CH", value: TiposCalculoManipulacao.CH },
        { text: "UI Percentual", value: TiposCalculoManipulacao.UIPercentual },
    ];

    @Prop(Number) quantidadeManipulacao: number;
    @Prop({ type: Number, required: true }) volumeFormulaPadrao: number;
    @Prop({ type: Number, default: 0 }) unidadeMedidaFormulaPadraoId: number;
    @Prop({ type: Number, default: null }) formaFarmaceuticaId: number;

    private getTipoItemManipulacaoPeloTipoProduto() {
        const tipoProduto = this.tipoItem != null ? this.tipoItem : TiposProduto.MateriaPrima;
        let tipoItemManipulacao = TiposItemManipulacao.MateriaPrima;

        switch (tipoProduto) {
            case TiposProduto.MateriaPrima:
                tipoItemManipulacao = TiposItemManipulacao.MateriaPrima;
                break;
            case TiposProduto.Embalagem:
                tipoItemManipulacao = TiposItemManipulacao.Embalagem;
                break;
            case TiposProduto.Capsula:
                tipoItemManipulacao = TiposItemManipulacao.Capsula;
                break;
            case TiposProduto.SemiAcabado:
                tipoItemManipulacao = TiposItemManipulacao.MateriaPrima;
                break;
            default:
                tipoItemManipulacao = TiposItemManipulacao.MateriaPrima;
        }

        return tipoItemManipulacao;
    }

    get showDose() {
        return this.model.tipoCalculo == TiposCalculoManipulacao.Dose;
    }

    private getTooltipUnidadeMedidaDose(unDose: number) {
        if (unDose != null && unDose > 0) {
            const unMed = this.unidadeMedidaOptions.filter(p => p["value"] == this.unidadeMedidaFormulaPadraoId);
            if (unMed.length > 0) {
                return this.unidadeMedidaOptions.filter(p => p["value"] == this.unidadeMedidaFormulaPadraoId)[0][
                    "text"
                ];
            }
        }

        return "";
    }

    private async loadProdutos() {
        const tipoProduto = this.tipoItem != null ? this.tipoItem : TiposProduto.MateriaPrima;

        switch (tipoProduto) {
            case TiposProduto.MateriaPrima:
                this.model.tipoItem = TiposItemManipulacao.MateriaPrima;
                break;
            case TiposProduto.Embalagem:
                this.model.tipoItem = TiposItemManipulacao.Embalagem;
                break;
            case TiposProduto.Capsula:
                this.model.tipoItem = TiposItemManipulacao.Capsula;
                break;
            case TiposProduto.SemiAcabado:
                this.model.tipoItem = TiposItemManipulacao.MateriaPrima;
                break;
            default:
                this.model.tipoItem = TiposItemManipulacao.MateriaPrima;
        }

        let produtosModel;

        if (Number(this.tipoItem) == 99) {
            produtosModel = await produtoESinonimosService.comboCached(this.usuarioLogado.franquiaId, true);
        } else {
            const data = await produtoESinonimosService.comboCached(this.usuarioLogado.franquiaId);
            produtosModel = data.filter(p => p.tipoProduto == this.tipoItem, true);
        }

        this.produtosOptions = produtosModel;
    }

    private async incluirItem() {
        try {
            const isValid = await this.$validator.validateAll(undefined, "item");
            if (isValid) {
                if (this.possuiKit) {
                    await this.addKitQuestion();

                    if (this.kitEmbalagemModel.id > 0) {
                        this.$emit("inclusao-kitEmbalagem", this.kitEmbalagemModel.id);
                    }
                }

                this.$emit("inclusao-item", await this.getModel());

                if (this.adicionarKit) {
                    await this.addKitItens();
                }

                this.clear();
                await this.$validator.reset({ scope: "item" });
            }
        } catch {}
    }

    private async addKitItens() {
        const quantidade = arithmeticHelper.round(this.model.quantidadeDose, 8);
        const fase = this.model.faseUso;

        if (this.kitEmbalagemModel != null) {
            const itensPadrao = this.kitEmbalagemModel.kitEmbalagemItens.filter(p => p.produtoPadrao);
            const unidadeMedida = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);

            for (let i = 0; i < itensPadrao.length; i++) {
                const modelKitItem = new FormulaPadraoItemModel();
                // Mantem os mesmos dados para todos os itens de embalagem
                modelKitItem.tipoCalculo = this.model.tipoCalculo;
                modelKitItem.volumeDose = this.model.volumeDose;

                this.clear();

                this.model.produtoId = itensPadrao[i].produtoId;
                await this.carregarProduto(true);
                this.model.tipoItem = TiposItemManipulacao.Embalagem;
                this.model.tipoCalculo = modelKitItem.tipoCalculo;
                this.model.volumeDose = modelKitItem.volumeDose;
                modelKitItem.updateFrom(this.model);
                modelKitItem.formulaPadraoId = this.model.id;
                modelKitItem.produtoDescricao = itensPadrao[i].produtoDescricao;
                modelKitItem.unidadeMedidaDescricao = unidadeMedida.find(
                    p => p.value == this.model.unidadeMedidaId,
                )?.text;
                modelKitItem.unidadeMedidaManipulacaoDescricao = unidadeMedida.find(
                    p => p.value == this.model.unidadeMedidaManipulacaoId,
                )?.text;
                modelKitItem.tipoItem = TiposItemManipulacao.Embalagem;
                modelKitItem.tipoItemDescricao = "Embalagem";
                modelKitItem.faseUso = fase;
                modelKitItem.quantidadeDose = itensPadrao[i].quantidade * quantidade;
                modelKitItem.quantidade = modelKitItem.quantidadeDose;

                const tipoCalc = this.tiposCalculoOptions.filter(p => p["value"] == this.model.tipoCalculo);
                modelKitItem.tipoCalculoDescricao = tipoCalc.length > 0 ? tipoCalc[0]["text"] : "";
                this.$emit("inclusao-item", modelKitItem);
            }
        }
    }

    private async addKitQuestion() {
        this.adicionarKit = false;
        const inputOptions = this.kitsModels.reduce(
            (result, p, index) => ({
                ...result,
                [index]: p.descricao,
            }),
            {},
        );
        this.possuiKit = false;

        if (this.kitsModels.length > 0) {
            const response = await this.$showAlert({
                title: this.$t("__.ts.escolhaKitParaVincu") as string,
                text: this.$t("__.ts.itensKitAddAuto") as string,
                icon: "question",
                html: this.$t("__.ts.vincularKitEmb") as string,
                input: "select",
                inputOptions: inputOptions,
                inputValidator: result => {
                    if (result != null && result != "") {
                        return "";
                    }
                    return this.$t("__.ts.casoNaoQueiraKit") as string;
                },
                showCancelButton: true,
                confirmButtonText: this.$t("__.ts.sim") as string,
                cancelButtonText: this.$t("__.ts.nao") as string,
            });

            if (response.isConfirmed) {
                this.kitEmbalagemModel = new KitEmbalagemModel();
                this.kitEmbalagemModel = this.kitsModels[response.value];
                this.kitEmbalagemModel.kitEmbalagemItens = this.kitEmbalagemModel.kitEmbalagemItens.filter(
                    p => p.produtoId != this.model.produtoId,
                );
                this.adicionarKit = true;
            }
        }
    }

    private async getModel() {
        const produtoElement = this.$el.querySelector("#produtoItemId") as HTMLSelectElement;
        const unidadeMedidaManipulacaoElement = this.$el.querySelector(
            "#unidadeMedidaManipulacaoItemId",
        ) as HTMLSelectElement;
        const tipoItemElement = this.$el.querySelector("#tipoItem") as HTMLSelectElement;

        const model = new FormulaPadraoItemModel();
        model.updateFrom(this.model);
        model.formulaPadraoId = this.model.id;

        const produto = await produtoService
            .getById(this.model.produtoId)
            .withLoading()
            .resolveWithJSON<ProdutoModel>();

        let produtoDescricao = produtoElement.innerText;

        if (produto != null) {
            produtoDescricao = produto.descricao;

            if (this.model.sinonimoId && produto.produtoSinonimos.some(p => p.id == this.model.sinonimoId)) {
                produtoDescricao = produto.produtoSinonimos.find(p => p.id == this.model.sinonimoId).sinonimo;
            }
        }

        const unidadeMedida = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);

        model.produtoDescricao = produtoDescricao; //produtoElement.innerText;
        model.unidadeMedidaDescricao = unidadeMedida.find(p => p.value == this.model.unidadeMedidaId)?.text;
        model.unidadeMedidaManipulacaoDescricao = unidadeMedidaManipulacaoElement.innerText;
        model.tipoItemDescricao = tipoItemElement.innerText;
        model.tipoItem = this.getTipoItemManipulacaoPeloTipoProduto();

        const tipoCalc = this.tiposCalculoOptions.filter(p => p["value"] == this.model.tipoCalculo);
        model.tipoCalculoDescricao = tipoCalc.length > 0 ? tipoCalc[0]["text"] : "";

        model.sinonimoId = this.model.sinonimoId;
        model.desmembrado = false;

        return model;
    }

    public clear() {
        this.initializeModel();
    }

    private initializeModel() {
        this.model = new FormulaPadraoItemModel();

        this.tipoItem = TiposProduto.MateriaPrima;
        this.model.tipoItem = TiposManipulacao.MateriaPrima;
        this.model.tipoCalculo = TiposCalculoManipulacao.Nenhum;
        this.model.quantidadeDose = 0;
        this.model.quantidade = 0;
        this.model.apenasLoteReprocessados = false;
        this.model.produtoLoteReprocessadoId = null;
        this.produtoId = null;
    }

    private calculoUnitario(item: FormulaPadraoItemModel, quantidade: number) {
        let qtde = item.quantidadeDose * (quantidade ?? 1);

        if (item.fatorCorrecao) {
            qtde *= item.fatorCorrecao;
        }

        return arithmeticHelper.round(qtde, 4);
    }

    private calculoPercentual(item: FormulaPadraoItemModel, unidadeMedida: number, volume: number) {
        item.unidadeMedidaManipulacaoId = unidadeMedida;

        let qtde = (item.quantidadeDose / 100) * volume;

        if (item.fatorCorrecao) {
            qtde *= item.fatorCorrecao;
        }

        return arithmeticHelper.round(qtde, 4);
    }

    public async calcularQuantidadeItem(item: FormulaPadraoItemModel, quantidadeManipulacao: number) {
        let quantidade = 0;
        let converter = true;

        switch (item.tipoCalculo) {
            case TiposCalculoManipulacao.Unitario:
                quantidade = this.calculoUnitario(item, quantidadeManipulacao);
                break;
            case TiposCalculoManipulacao.Percentual:
                quantidade = this.calculoPercentual(item, this.unidadeMedidaFormulaPadraoId, this.volumeFormulaPadrao);
                break;
            case TiposCalculoManipulacao.Qsp:
                item.quantidadeDose = 0;
                break;
            default:
                converter = false;
                const unidadeMedida = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);
                const unidade = unidadeMedida.find(p => p.text == "un");
                const isUnidade = unidade ? unidade.value == item.unidadeMedidaManipulacaoId : false;

                const indiceConversao = isUnidade
                    ? 1
                    : await this.getIndiceConversao(
                          item.unidadeMedidaManipulacaoId,
                          item.produtoUnidadeMedidaEstoqueId,
                          item.produtoDensidade,
                          item.produtoId,
                      );

                item.quantidade = arithmeticHelper.round(item.quantidadeDose * indiceConversao, 8);
        }

        if (converter) {
            const indice = await this.getIndiceConversao(
                item.unidadeMedidaManipulacaoId,
                item.produtoUnidadeMedidaEstoqueId,
                item.produtoDensidade,
                item.produtoId,
            );

            if (quantidade > 0) {
                item.quantidade = quantidade * indice;
            }
        }

        return item;
    }

    private async getIndiceConversao(
        unidadeMedidaOrigem: number,
        unidadeMedidaDestino: number,
        densidade: number,
        produtoId: number,
    ) {
        const indice = await this.indicesConversoesUnidadeMedidasService.getIndiceConversao(
            unidadeMedidaOrigem,
            unidadeMedidaDestino,
            densidade,
            produtoId,
        );
        return indice > 0 ? indice : 1;
    }

    //@ts-ignore
    @Watch("model.tipoCalculo")
    private async onTipoCalculoChanged() {
        if (this.model.tipoCalculo == TiposCalculoManipulacao.Qsp) {
            const buscarUnidadesPadroes = u => u.text.includes("g") || u.text.includes("ml");
            this.loadUnidadesMedidaManipulacao(buscarUnidadesPadroes);
        } else {
            this.loadUnidadesMedidaManipulacao();
        }

        this.model = await this.calcularQuantidadeItem(this.model, this.quantidadeManipulacao);
    }

    private async loadUnidadesMedidaManipulacao(filtro = null) {
        try {
            let data = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);

            if (filtro != null) {
                data = data.filter(filtro);
            }

            this.unidadesMedidaManipulacaoOptions = data;
        } catch {}
    }

    //@ts-ignore
    @Watch("model.quantidadeDose")
    private async onQuantidadeDoseChanged() {
        this.model = await this.calcularQuantidadeItem(this.model, this.quantidadeManipulacao);
    }

    @Watch("volumeFormulaPadrao")
    private async onVolumeTotalChanged() {
        this.model = await this.calcularQuantidadeItem(this.model, this.quantidadeManipulacao);
    }

    @Watch("quantidadeManipulacao")
    private async onChangeQuantidadeManipulacao() {
        this.model = await this.calcularQuantidadeItem(this.model, this.quantidadeManipulacao);
    }

    //@ts-ignore
    @Watch("model.fatorCorrecao")
    private async onFatorCorrecaoChanged() {
        this.model = await this.calcularQuantidadeItem(this.model, this.quantidadeManipulacao);
    }

    //@ts-ignore
    @Watch("tipoItem")
    private onTipoItemChanged() {
        this.loadProdutos();
    }

    //@ts-ignore
    @Watch("produtoId")
    private onChangeProdutoId(newValue: number, oldValue: number) {
        if (!newValue || newValue == oldValue) {
            return;
        }

        const oldProdutoId = this.model.produtoId;
        const oldSinonimoId = this.model.sinonimoId;

        const produtos = this.produtosOptions.filter(p => p["value"] == this.produtoId);
        this.changeProdutoId = true;

        if (produtos.length > 0 && produtos[0]["sinonimoId"]) {
            this.model.produtoId = produtos[0]["produtoId"];
            this.model.sinonimoId = produtos[0]["sinonimoId"];
            this.model.produtoDescricao = produtos[0]["text"];
        } else {
            this.model.produtoId = this.produtoId;
            this.model.sinonimoId = null;
        }

        // Se trocou de sinonimo para outro sinonimo do mesmo produto ou para o proprio produto deve recarregar os dados
        if (
            (this.model.sinonimoId || oldSinonimoId) &&
            this.model.produtoId == oldProdutoId &&
            this.model.sinonimoId != oldSinonimoId
        ) {
            this.carregarProduto();
        }
    }

    //@ts-ignore
    @Watch("model.produtoId")
    private async onProdutoIdChanged(newValue: number, oldValue: number) {
        if (!newValue || newValue == oldValue) {
            return;
        }

        this.model.produtoLoteReprocessadoId = null;

        if (this.model.apenasLoteReprocessados) {
            await this.carregarLotesReprocessados();
        }

        this.loadProdutoId();
        this.carregarProduto();
    }

    private async carregarLotesReprocessados() {
        if (!this.model.produtoId) {
            this.lotesReprocessadosOptions = [];
            return;
        }

        try {
            const lotes = await new ProdutoLoteService()
                .getLotesReprocessadosByProduto(this.model.produtoId)
                .withLoading()
                .resolveWithJSON<ProdutoLoteModel[]>();

            const exibeCodigo = this.isFracionamento || this.isEstereis;
            this.lotesReprocessadosOptions = lotes.map(item => getProdutoLoteCombo(item, exibeCodigo));
        } catch {}
    }

    //@ts-ignore
    @Watch("model.unidadeMedidaManipulacaoId")
    private async onUnidadeMedidaManipulacaoIdChanged(newValue: number) {
        if (!newValue || newValue == 0) return;

        this.model = await this.calcularQuantidadeItem(this.model, this.quantidadeManipulacao);
    }

    private loadProdutoId() {
        if (!this.changeProdutoId) {
            if (this.model.sinonimoId && this.model.produtoId) {
                this.produtoId = this.model.sinonimoId * this.model.produtoId;
            } else {
                this.produtoId = this.model.produtoId;
            }
        }
        this.changeProdutoId = false;
    }

    private async carregarProduto(produtoKit = false) {
        let verificarKitEmbalagem = false;

        try {
            const data = await produtoService
                .getById(this.model.produtoId)
                .withLoading()
                .resolveWithJSON<ProdutoModel>();

            this.model.fatorCorrecao = null;
            if (data.fatorCorrecao) {
                this.model.fatorCorrecao = data.fatorCorrecao;
            }

            if (data.tipoCalculo && !this.updateMode) {
                this.model.tipoCalculo = data.tipoCalculo;
            }

            if (data.subGrupo == SubGrupoProduto.Recipiente && !produtoKit && !this.updateMode) {
                //verificar se possui kit embalagem
                verificarKitEmbalagem = true;
            }
            if (data.densidade) {
                this.model.produtoDensidade = data.densidade;
            }

            this.model.produtoUnidadeMedidaEstoqueId = data.unidadeMedidaEstoqueId;
            this.model.unidadeMedidaId = data.unidadeMedidaEstoqueId;

            if (!this.updateMode) {
                this.model.unidadeMedidaManipulacaoId = data.unidadeMedidaManipulacaoId;
            }

            let tipoItemManipulacao = TiposItemManipulacao.MateriaPrima;
            switch (data.tipoProduto) {
                case TiposProduto.MateriaPrima:
                    tipoItemManipulacao = TiposItemManipulacao.MateriaPrima;
                    break;
                case TiposProduto.Embalagem:
                    tipoItemManipulacao = TiposItemManipulacao.Embalagem;
                    break;
                case TiposProduto.Capsula:
                    tipoItemManipulacao = TiposItemManipulacao.Capsula;
                    break;
                case TiposProduto.SemiAcabado:
                    tipoItemManipulacao = TiposItemManipulacao.MateriaPrima;
                    break;
                default:
                    tipoItemManipulacao = TiposItemManipulacao.MateriaPrima;
            }
            this.model.tipoItem = tipoItemManipulacao;

            if (!produtoKit) {
                this.kitsModels = null;
                this.kitEmbalagemModel = null;
                this.possuiKit = false;
                if (verificarKitEmbalagem) {
                    //buscar kit embalagem para este recipiente
                    await this.carregarKitEmbalagem();
                }
            }
        } catch {}
    }

    private async carregarKitEmbalagem() {
        this.possuiKit = false;

        try {
            const data = await kitEmbalagemService
                .getKitByRecipiente(this.model.produtoId, this.formaFarmaceuticaId)
                .withLoading()
                .resolveWithJSON<KitEmbalagemModel[]>();

            this.possuiKit = data.length > 0;
            this.kitsModels = data;
        } catch {}
    }

    public async refazModel(model: FormulaPadraoItemModel) {
        this.updateMode = true;
        this.model.updateFrom(model);

        await this.carregarProduto();
        this.model = await this.calcularQuantidadeItem(this.model, this.quantidadeManipulacao);

        const modelRetorno = new FormulaPadraoItemModel();
        modelRetorno.updateFrom(this.model);

        modelRetorno.formulaPadraoId = model.formulaPadraoId;

        const produto = await produtoService
            .getById(this.model.produtoId)
            .withLoading()
            .resolveWithJSON<ProdutoModel>();

        let produtoDescricao = "";

        if (produto != null) {
            produtoDescricao = produto.descricao;

            if (produto.sinonimos != null && produto.sinonimos != "") {
                produtoDescricao = produto.sinonimos;
            }
        }

        modelRetorno.produtoDescricao = produtoDescricao;
        const unidadeMedida = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);

        modelRetorno.unidadeMedidaDescricao = unidadeMedida.filter(p => p.value == this.model.unidadeMedidaId)[0].text;
        modelRetorno.unidadeMedidaManipulacaoDescricao = unidadeMedida.filter(
            p => p.value == this.model.unidadeMedidaManipulacaoId,
        )[0].text;

        modelRetorno.tipoItemDescricao = EnumExtensions.getNameByValue(TiposManipulacao, modelRetorno.tipoItem);

        const tipoCalc = this.tiposCalculoOptions.filter(p => p["value"] == this.model.tipoCalculo);
        modelRetorno.tipoCalculoDescricao = tipoCalc.length > 0 ? tipoCalc[0]["text"] : "";

        this.updateMode = false;
        return modelRetorno;
    }

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);
        this.isFracionamento = await this.GET_IS_FRACIONAMENTO();
        this.isEstereis = await this.GET_IS_ESTEREIS();

        this.initializeModel();

        this.unidadesMedidaManipulacaoOptions = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId);

        await this.loadProdutos();
    }

    private async onApenasLoteReprocessadosChange() {
        if (this.model.apenasLoteReprocessados) {
            if (!this.model.produtoId) {
                this.model.produtoLoteReprocessadoId = null;
                return;
            }

            await this.carregarLotesReprocessados();
        } else {
            this.model.produtoLoteReprocessadoId = null;
        }
    }
}
